import type * as models from 'pkg/api/models';
import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Dateable } from 'pkg/api/models/dateable';
import type { RecurringInterval } from 'pkg/api/models/provider_settings';
import type { TaxRate } from 'pkg/api/models/tax_rate';
import type { UserProduct } from 'pkg/api/models/user_product';

type SubscriptionRowTypes = 'product' | 'fee' | 'discount';

export enum SubscriptionTypes {
	Installment = 'installment',
	Subscription = 'subscription',
}

export enum SubscriptionStatus {
	Unknown = 'unknown',
	Active = 'active',
	Canceled = 'canceled',
	Trialing = 'trialing',
	Scheduled = 'scheduled',
	Completed = 'completed',
	Pending = 'pending',
	Uncollectible = 'uncollectible',
}

export interface SubscriptionRow extends Dateable {
	id: number;
	productPriceId: number;
	quantity: number;
	subscriptionId: number;
	taxRateId: number;
	userId?: number;
	userProductId: number;
	validTo: number;
	amount?: number;
	discountId?: number;
	type: SubscriptionRowTypes;

	taxRate: TaxRate;
	userProduct: UserProduct;
	productPrice: models.productPrice.ProductPrice;
	discount?: models.discount.Discount;
	user?: models.user.User;
}

export interface Subscription extends Dateable, AllowedActionable {
	links?: { 'show:payment_method'?: string };
	accountId: number;
	currency: string;
	/** The customer's billing country, from their billing address. */
	country?: string;
	currentPeriodStart: number;
	currentPeriodEnd: number;
	customerUserId: number;
	collectionMethod: 'automatic' | 'manual';
	description: string;
	daysUntilDue: number;
	groupId: number;
	id: number;
	latestInvoiceDueDate: number;
	recurringInterval: RecurringInterval;
	recurringIntervalCount: number;
	startAt: number;
	endAt: number;
	trialEndAt: number;
	jobStatus: string;
	stripeCouponId: number;
	paymentProviderId: string;
	userPaymentMethodId: number;
	status: SubscriptionStatus;
	installmentCount: number;
	publicId: string;
	publicUrl: string;
	installmentsPaid: number;
	installmentsBilled: number;
	discountDeliveredAmount: number;
	discountDeliveredPayments: number;
	installmentPaidAmount: number;
	installmentInvoicedAmount: number;
	installmentTotalAmount: number;
	amountRecurring: number;

	nextOrder?: models.order.Order;
	customerUser: models.user.User;
	rows: SubscriptionRow[];
	type: SubscriptionTypes;
	orders: models.order.Order[];
	paymentMethod?: models.paymentMethod.PaymentMethod;
	userPaymentMethod?: models.paymentMethod.PaymentMethod;
}
